import styled from "styled-components"

export const HoverCardContainer = styled.div`
  display: flex;
  width: 100%;
  font-family: 'DM sans';
  
  .hover-card-trigger {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    padding: 8px 0;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    cursor: help;
    font-size: 13px;
    font-weight: 600;
  }

  .hover-card-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    height: fit-content;
    z-index: 999;
  }
  `

export const HoverInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 22rem;
  padding: 0.5rem;
  height: fit-content;
  max-height: 24rem;
  overflow-y: auto;
  overflow-x: hidden;
  background: var(--black-300);
  border: 1px solid var(--white);

  .pr-info {
    display: flex;
    width: 100%;
    justify-content: space-between;

    span:first-of-type {
      display: block;
      font-size: 14px;
      font-weight: 700;
      color: #f6f5fc;
    }

    span:last-of-type {
      display: block;
      font-size: 14px;
    }

    button {
      border: 1px solid var(--black-400);
      background: var(--black-400);
      font-size: 12px;
      font-weight: 500;
      color: var(--white);
      border-radius: 4px;
      padding: 4px 12px;
      transition: all ease-in-out 300ms;

      &:hover {
        border: 1px solid var(--white);
      }
    }
  }
`